import { ApiConfig } from '../constants/Constants';

type CurrentEnvironment = 'local' | 'dev' | 'preprod' | 'prod';

/** Get current environment */
export const getCurrentEnvironment = (): CurrentEnvironment => {
  const url = (ApiConfig.api_base_url || '').toLowerCase();
  if (url.includes('dev')) return 'dev';
  if (url.includes('preprod')) return 'preprod';
  if (url.includes('localhost')) return 'local';
  return 'prod';
};

/** Get current environment label */
export const getEnvLabel = (): string => {
  const currentEnv = getCurrentEnvironment();

  if (currentEnv == 'dev') return 'DEV';
  if (currentEnv == 'preprod') return 'PRE';
  return '';
};
